import type { IconSvgObject } from './types';

const ArrowUpLeft01Icon: IconSvgObject = [
  ["path", { d: "M6.50004 15V6.5H15M6.92858 6.9286L17.5 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowUpLeft01Icon;
